/**
 * Tokens in localStorage.
 *
 * Cookies are avoided on purpose: inside the Telegram WebView they behave
 * unpredictably. Every access is guarded — private mode and blocked site data
 * make localStorage throw.
 */
import type { Tokens } from '@/api/types'

const KEY = 'airoundme.tokens'

export function readTokens(): Tokens | null {
  try {
    const raw = localStorage.getItem(KEY)
    return raw ? (JSON.parse(raw) as Tokens) : null
  } catch {
    return null
  }
}

export function writeTokens(tokens: Tokens | null): void {
  try {
    if (tokens) {
      localStorage.setItem(KEY, JSON.stringify(tokens))
    } else {
      localStorage.removeItem(KEY)
    }
  } catch {
    // A session that lives only in memory still works for this visit
  }
}
